
 
export default {
  namespaced: true,
  state: {
    drugToDispenseId: null,
  },
  getters: {
    drugToDispenseId: (state) => state.drugToDispenseId,
  },
  mutations: {
    SET_DRUG_TO_DISPENSE_ID(state, id) {
      state.drugToDispenseId = id;
    },
  },
  actions: {
    setDrugToDispenseId({ commit }, id) {
      commit('SET_DRUG_TO_DISPENSE_ID', id);
    },
  },
};
